var map = {
	"./Blood Pressure.svg": 942,
	"./Heart Rate.svg": 943,
	"./Respiratory Rate.svg": 944,
	"./SpO2.svg": 945,
	"./afDetected.svg": 946,
	"./afNotDetected.svg": 222,
	"./bt.svg": 223,
	"./calories.svg": 323,
	"./medcine_reminder.svg": 322,
	"./notMeasured.svg": 947,
	"./pointer.svg": 224,
	"./print.svg": 468,
	"./sleep.svg": 324,
	"./steps.svg": 325,
	"./watch.svg": 225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;